import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MessageContact } from '../../types';

export type State = MessageContact[];

const initialState: State = [];

export const ContactSlice = createSlice({
  name: 'contacts',
  initialState,
  reducers: {
    onSetContacts: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteContacts: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetContacts, onDeleteContacts } = ContactSlice.actions;

export default ContactSlice.reducer;
